import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import useResponsive from "../../hooks/useResponsive";
import { aSync } from "../../utils/helper";

interface ModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  minHeight?: number;
  maxHeight?: number;
  initialFocusRef?: React.RefObject<any>;
  children?: React.ReactNode;
  padding?: number;
  maxWidth?: number;
  className?: string;
}

export default function Modal({
  isOpen,
  onDismiss,
  minHeight = 0,
  maxHeight = 90,
  children,
  maxWidth = 430,
}: ModalProps) {
  const { isMd } = useResponsive();
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      aSync(
        10,
        function () {
          const getStyle = document.getElementById("headlessui-portal-root");
          return !getStyle;
        },
        function () {
          setIsCloseModal(true);
        }
      );
    } else {
      setIsCloseModal(false);
    }
  }, [isOpen]);

  if (!isCloseModal) {
    return null;
  }
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          onClose={onDismiss}
          className="fixed inset-0 z-50 overflow-hidden "
        >
          <Dialog.Overlay className="fixed inset-0 zBg-3  opacity-80" />
          <div className="flex items-center justify-center h-screen px-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div
                className="transition-all transform"
                style={{
                  width: isMd ? "65vw" : "90%",
                  maxWidth: `${maxWidth}px`,
                }}
              >
                <div className="w-full p-px rounded bg-gradient-to-r from-blue to-pink">
                  <div
                    className="mainModel--flag flex flex-col w-full h-full p-6 rounded zBg-4 overflow-hidden shadow-md zBorder-1 border"
                    style={{
                      minHeight: `${minHeight}vh`,
                      maxHeight: `${maxHeight}vh`,
                    }}
                  >
                    {children}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
